import React from 'react';
import Search from 'components/search';
import { Icon } from 'components/ui/icon';

interface IProps {
  /** URL query string (e.g. `location.search`) forwarded to Search for URL sync. */
  queryParams?: string;
  onRefresh?: () => void;
  lastUpdateMessage?: string;
  refreshTestId?: string;
}

const TableToolbar = ({
  queryParams,
  onRefresh,
  lastUpdateMessage,
  refreshTestId,
}: IProps): JSX.Element => {
  return (
    <div className="flex max-sm:flex-col gap-2 items-center mb-3">
      <Search queryParams={queryParams} />
      {onRefresh && (
        <div className="flex items-center md:ml-4">
          <Icon
            name="clock"
            size={16}
            className="text-gray-blue-50"
            aria-hidden="true"
          />
          {lastUpdateMessage && (
            <div className="ml-1 mr-10 text-xs text-gray-blue-50">
              {lastUpdateMessage}
            </div>
          )}
          <button
            type="button"
            onClick={onRefresh}
            data-testid={refreshTestId}
            className="flex items-center gap-1 text-xs text-dark-green-link cursor-pointer bg-transparent border-0 p-0"
          >
            <Icon name="refresh" size={16} aria-hidden="true" />
            Refresh
          </button>
        </div>
      )}
    </div>
  );
};

export default TableToolbar;
